import React from "react";
import { WPImage } from "../../../constants/types";
import { Wrapper, Inner, Image, Content, Title, Appearances } from "./styled";

interface Props {
    title: string;
    image?: WPImage;
    to: string;
    appearance?: Appearances;
}

export const PopulationCard = (props: Props) => {
    return (
        <Wrapper to={props.to} appearance={props.appearance ?? Appearances.primary}>
            <Inner>
                <Image src={props.image?.url} alt="" />
                <Content>
                    <Title useSmallerText={props.title.length > 20}>{props.title}</Title>
                </Content>
            </Inner>
        </Wrapper>
    );
};
